module.exports = __webpack_public_path__ + "static/media/gear-animation-3.d1f4b3b9.svg";